var _style, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaproLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 350,
    viewBox: "0 0 351 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        #metapro-loader{\r\n            background-color: black;\r\n            width: 100vw;\r\n            height: 200vh;\r\n        }\r\n        #loader-outline{\r\n            animation: loader-outline-animation 1s infinite linear;\r\n            transform-origin: center;\r\n            filter: drop-shadow(0 0 20px rgba(255, 26, 80)) drop-shadow(0 0 20px rgba(255, 26, 80));\r\n        }\r\n        @keyframes loader-outline-animation {\r\n            from {transform: rotate(0deg);}\r\n            to {transform: rotate(360deg);}\r\n        }\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 251,
    height: 250,
    rx: 125,
    fill: "url(#paint0_linear_1998_1053)",
    filter: "url(#filter0_iiiiiii_1998_1053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.719 118.302C234.583 115.552 231.628 113.714 228.666 113.902C209.412 114.797 191.53 119.677 175.478 128.394C159.354 119.653 141.592 114.793 122.344 113.899C121.358 113.848 120.372 113.999 119.446 114.341C118.52 114.684 117.673 115.211 116.957 115.892C116.241 116.572 115.672 117.391 115.282 118.298C114.893 119.206 114.693 120.183 114.693 121.17V203.659C114.695 206.035 115.516 208.338 117.019 210.178L136.436 233.903L136.551 234.051C139.767 238.014 146.266 235.893 146.537 230.799C147.793 208.009 158.308 186.415 175.485 171.175C192.462 186.291 203.205 207.917 204.467 230.79C204.53 231.924 204.935 233.011 205.629 233.909C207.701 236.748 212.299 236.819 214.449 234.037L234.158 209.954C234.567 209.453 234.911 208.901 235.18 208.312C235.916 206.87 236.302 205.275 236.307 203.656V121.173C236.309 120.186 236.109 119.208 235.719 118.302ZM146.464 204.09V169.448C146.464 169.226 146.47 169.005 146.484 168.786C146.69 163.265 152.175 158.84 157.605 159.664C159.885 159.92 161.824 161.198 163.733 162.378C166.298 163.974 168.777 165.705 171.159 167.563C160.101 177.568 151.628 190.1 146.464 204.09ZM230.27 205.574C230.2 205.885 230.057 206.176 229.854 206.421L211.393 228.988L210.945 229.535L210.104 230.558L210.072 230.532L210.028 230.48C208.811 206.759 197.575 183.399 179.789 167.516L179.838 167.473C176.234 164.399 172.437 161.338 168.454 158.781C165.77 157.11 163.129 155.19 160.01 154.457C153.717 152.774 146.5 155.8 143.185 161.326C141.674 163.764 140.879 166.578 140.893 169.446V230.375H140.981C140.981 230.392 140.981 230.408 140.981 230.425H140.853L140.779 230.404L121.329 206.646C120.64 205.803 120.264 204.748 120.263 203.659V121.165C120.263 120.934 120.31 120.706 120.401 120.494C120.492 120.281 120.625 120.09 120.792 119.93C150.832 119.153 180.012 133.563 201.242 154.669C214.681 167.864 227.359 190.416 230.27 205.574ZM230.737 189.144C225.828 177.714 219.36 166.902 211.325 157.385C202.707 147.343 192.407 138.661 181.201 131.667C195.71 124.362 211.742 120.26 228.941 119.461C229.172 119.45 229.403 119.486 229.62 119.567C229.837 119.648 230.035 119.772 230.202 119.932C230.369 120.092 230.502 120.284 230.593 120.497C230.684 120.71 230.731 120.939 230.731 121.17L230.737 189.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "loader-outline",
    cx: 175,
    cy: 175,
    r: 120.833,
    stroke: "url(#paint0_linear_1995_1043)",
    strokeWidth: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiiiiii_1998_1053",
    x: 38.8889,
    y: 41.6667,
    width: 281.556,
    height: 283.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.77778,
    dy: 2.77778
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.8889,
    dy: 11.1111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.111979 0 0 0 0 0.127193 0 0 0 0 0.208333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1998_1053",
    result: "effect2_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.8889,
    dy: 11.1111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.5556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.178681 0 0 0 0 0.191257 0 0 0 0 0.258333 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1998_1053",
    result: "effect3_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.8889,
    dy: 11.1111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.4444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.413194 0 0 0 0 0.426968 0 0 0 0 0.495833 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1998_1053",
    result: "effect4_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 19.4444,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.3333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_1998_1053",
    result: "effect5_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.1111,
    dy: -8.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_1998_1053",
    result: "effect6_innerShadow_1998_1053"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.3717,
    dy: 10.3717
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.64309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect6_innerShadow_1998_1053",
    result: "effect7_innerShadow_1998_1053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1998_1053",
    x1: 175.5,
    y1: 50,
    x2: 175.5,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1995_1043",
    x1: 250,
    y1: 152.778,
    x2: 12.5,
    y2: 98.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1A50",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaproLoader);
export default __webpack_public_path__ + "static/media/metapro-loader.821a714336beb1a8084319804390aaa9.svg";
export { ForwardRef as ReactComponent };